<template>
  <div class="gh-form gh-form--newsletter">
    <div class="gh-form__wrapper">
      <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated zoomOut" mode="out-in">
        <div class="gh-form__response" v-if="subscribed">
          <el-alert
            title="Subscribed successfully"
            type="success"
            showIcon
            description="Thank you for subscribing our e-newsletter!"
            :closable="false">
          </el-alert>
        </div>
        <el-form
          v-else
          :model="form"
          :rules="form.validationRules"
          @keyup.enter.native="attemptSubmit('elForm')"
          ref="elForm"
          class="gh-form__content">
          <div class="gh-form__group row">
            <el-form-item prop="fullName" class="col-xs-12 col-md-4 col-lg-4">
              <el-input v-model="form.fullName" placeholder="Firstname*" name="name"></el-input>
            </el-form-item>

            <el-form-item prop="email" class="col-xs-12 col-md-4 col-lg-4">
              <el-input type="email" v-model="form.email" placeholder="Email Address*" name="email"></el-input>
            </el-form-item>

            <el-form-item prop="professionId" class="col-xs-12 col-md-4 col-lg-4">
              <gh-profession-selector @change="changeProfession"/>
            </el-form-item>

            <el-form-item class="gh-accept-field">
              <el-checkbox v-model="form.promotionAccepted" class="gh-accept">I would like to receive limited Mental
                Health Academy event invitations, offers and learning opportunities
              </el-checkbox>
            </el-form-item>
          </div>

          <vue-recaptcha
            ref="recaptcha"
            :sitekey="recaptchaSitekey"
            size="invisible"
            badge="bottomleft"
            @verify="setRecaptchaToken"/>

          <div class="gh-form__actions">
            <el-button
              class="gh-button-redesign gh-button--submit"
              @click="attemptSubmit('elForm')" :loading="loading" :disabled="loading">
              {{ computedSubmitButtonLabel }}
            </el-button>
          </div>
        </el-form>
      </transition>
    </div>
  </div>
</template>

<script>
import formMixin from '@/modules/form/mixins/form';
import Form from '@/modules/form/models/Form';
import ghProfessionSelector from '@/modules/profession/components/ProfessionSelector';

export default {
  mixins: [formMixin],

  components: {
    VueRecaptcha: () => import(/* webpackChunkName: "recaptcha" */ 'vue-recaptcha'),
    ghProfessionSelector
  },

  data() {
    return {
      loading: false,
      form: new Form({
        email: '',
        fullName: '',
        promotionAccepted: false,
        professionId: '',
        recaptcha: null,
        newsletterSource: location.pathname
      }),
      submitButtonLabel: 'Subscribe',
      subscribed: false
    }
  },

  computed: {
    recaptchaSitekey() {
      return LaraVue.recaptcha;
    },

    computedSubmitButtonLabel() {
      return this.loading
        ? 'Please wait...'
        : this.submitButtonLabel
    }
  },

  methods: {
    attemptSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.scrollToError(formName);
          return false;
        }

        this.loading = true
        this.requestRecaptchaToken()
      });
    },

    requestRecaptchaToken() {
      this.$refs.recaptcha.reset()
      this.$refs.recaptcha.execute()
    },

    setRecaptchaToken(token) {
      this.form.recaptcha = token

      this.form.post('/api/v1/newsletter/guest', {
        mhaUrl: location.pathname,
      })
        .then(_ => {
          this.loading = false
          this.subscribed = true
        })
        .catch(({data}) => {
          this.loading = false
          this.formFailure(data)
        })
    },
    changeProfession(profession) {
      this.form.professionId = profession;
    },
  }
}
</script>

<style lang="scss" scoped>
.gh-accept {
    display: flex;
    color: #fff;
}

.gh-accept-field {
    margin-left: .7rem;
}

@media screen and (min-width: 768px) {
    .gh-form--newsletter {
        .gh-form__group {
            flex-flow: row wrap;
        }

        .gh-accept-field {
            width: 100%;
            flex-basis: 100%;
            margin-top: 1rem;
        }

        .el-form-item {
            &.is-error {
                margin-bottom: 0.5rem;
            }
        }
    }
}
</style>

<style lang="scss">
.gh-form--newsletter {
    .el-checkbox__label {
        font-weight: 400;
        font-size: 1rem;
    }
}
</style>
